export function mergeProviderMessages(groups = []) {
  return [...new Map(groups.flat().filter(Boolean).map((item) => [String(item.id), item])).values()]
    .sort((left, right) => new Date(right.createdAt || 0) - new Date(left.createdAt || 0));
}

export function replaceProviderMessages(current, provider, kind, incoming, issue = '') {
  const matches = (item) => item.provider === provider && (item.type === 'comment' ? 'comments' : 'messages') === kind;
  const previous = current.filter(matches);
  const next = incoming.map((item) => ({ ...item }));
  return mergeProviderMessages([current.filter((item) => !matches(item)), issue ? mergeProviderMessages([previous, next]) : next]);
}

export function conversationKey(item) {
  return item.conversationId || `${item.provider}:${item.accountId}:${item.senderId || item.from}`;
}

export function conversationList(items, kind) {
  const relevant = items.filter((item) => (item.type === 'comment' ? 'comments' : 'messages') === kind);
  if (kind === 'comments') return relevant;
  const latest = new Map();
  relevant.forEach((item) => {
    const key = conversationKey(item);
    if (!latest.has(key) || new Date(item.createdAt || 0) > new Date(latest.get(key).createdAt || 0)) latest.set(key, item);
  });
  return [...latest.values()];
}

export function mergeProviderAccounts(groups = []) {
  return [...new Map(groups.flat().filter(Boolean).map((account) => [
    `${account.provider || 'provider'}:${account.id}`,
    account
  ])).values()];
}

export function friendlyProviderIssue(value) {
  const issue = String(value || '').trim();
  if (!issue) return '';
  if (/oauth|code\s*190|must be granted before impersonating|pages_messaging|instagram_manage_messages/i.test(issue)) {
    return 'Meta Inbox access is unavailable. Reconnect after the required messaging permissions are approved.';
  }
  return issue.length > 180 ? `${issue.slice(0, 177)}...` : issue;
}

export function providerIssues(results = {}) {
  const grouped = new Map();
  Object.entries(results).forEach(([provider, result]) => {
    const issue = friendlyProviderIssue(result?.issue);
    if (!issue) return;
    const label = `${provider[0].toUpperCase()}${provider.slice(1)}`;
    grouped.set(issue, [...(grouped.get(issue) || []), label]);
  });
  return [...grouped.entries()].map(([issue, providers]) => `${providers.join(' and ')}: ${issue}`).join(' ');
}
